export const PLAN_MONTHLY_CREDITS = {
  Lite: 2000,
  Standard: 5000,
  Pro: 25000,
  Ultra: 70000
} as const;

export const PAID_DAILY_REFRESH_CREDITS = 100;

export const DAILY_REFRESH_CREDITS_TOOLTIP =
  'Free daily credits for paid users';
